import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { VersionsService } from '../services/versions.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class VersionListResolver implements Resolve<Observable<string>> {

    constructor(private versionsService: VersionsService) { }

    resolve() {
        return this.versionsService.getVersions().catch(() => {
            return Observable.of('error');
        });
    }
}
